import { useState } from "react";
import "./TooltipUI.css";

const TooltipUI = ({ children, text }) => {
  const [show, setShow] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && text && (
        <div className="tooltip">
          {text}
          <span className="tooltip-arrow" />
        </div>
      )}
    </div>
  );
};

export default TooltipUI;